export default __webpack_public_path__ + "b9260c9169b2159630567ced4c66fb25.svg";